import FormController from '../components/form_controller';

export default class extends FormController { }
